import z from "zod";

export const getCrewDefinitionParamSchema = z.object({
	crewDefinitionId: z.uuid(),
});

export type GetCrewDefinitionParamSchema = z.infer<typeof getCrewDefinitionParamSchema>;
